import { render } from "./PersonalInformation.vue?vue&type=template&id=08aced92&scoped=true"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"

import "./PersonalInformation.vue?vue&type=style&index=0&id=08aced92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08aced92"

export default script